import moment from "moment";
import ReactApexChart from "react-apexcharts";
import { colorPalette, monthNames } from "./chartOption";

interface QuantityMaterialProps {
    quantityPerMonth: Map<string, number>;
}
const QuantityPerMonth = ({ quantityPerMonth }: QuantityMaterialProps) => {
    const colors = colorPalette.slice(
        0,
        Array.from(quantityPerMonth.keys()).length
    );
    const chartData = {
        options: {
            chart: {
                id: "quantity",
            },
            xaxis: {
                categories: monthNames,
            },
            colors: colors,
            dataLabels: {
                enabled: false,
            },
            title: {
                text: 'Quantity per month'
              },
        },
        series: [
            {
                name: "Quantity",
                data: Array.from(quantityPerMonth.values()),
            },
        ],
    };

    return (
        <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={300}
        />
    );
};

export default QuantityPerMonth;
